import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), React.createElement("path", {
  d: "M9 11h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2zM16.0564 3.3465l1.2812-1.5358 4.6074 3.8436-1.2812 1.5358zM3.3367 7.1896L2.0555 5.6538l4.6074-3.8436L7.944 3.346z"
}), React.createElement("path", {
  d: "M12 6c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-2c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9z"
})), 'SnoozeOutlined');